<template>
    <div class="sidebar">
        <router-link
                class="nav-sidebar-tab"
                title="Profile"
                :class="{active: active('userProfile')}"
                :to="{name: 'userProfile'}"
        >
            <i class="icon-user"></i>
        </router-link>

        <router-link
                class="nav-sidebar-tab"
                title="Trims"
                :class="{active: active('userCreatedTrims')}"
                :to="{name: 'userCreatedTrims'}"
        >
            <i class="icon-flow-line"></i>
        </router-link>

        <router-link
                class="nav-sidebar-tab"
                title="Statistic"
                :class="{active: active('userStatistic')}"
                :to="{name: 'userStatistic'}"
        >
            <i class="icon-signal"></i>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "UserPageMenu",

        props: [
            'current',
        ],

        methods: {
            active(...args) {
                return args.flat().find(page => page === this.current);
            },

        },

    }
</script>

<style>

</style>